export const SUPPORTING_DOCUMENTS = 'supporting-documents';
export const TCDWCL_QUALIFICATION_DETAILS = 'tcdwcl-qualification-details';
export const TCDWCL_EMPLOYMENT_DETAILS = 'tcdwcl-employment-details';

export const AMEND_TCDWCL_LICENCE = [
    {
        sectionID: TCDWCL_QUALIFICATION_DETAILS,
        sectionName: 'Qualification Details',
        fieldList: [
            {
                id: 'tcdwcl-qualification-details',
                label: '',
                type: 'table2',
                subFields: [
                    {
                        id: 'certificate-type',
                        header: 'Certificate Type',
                        type: 'text'
                    },
                    {
                        id: 'course-name',
                        header: 'Course Name',
                        type: 'text'
                    },
                    {
                        id: 'certificate-name',
                        header: 'Certificate Name',
                        type: 'text'
                    },
                    {
                        id: 'date-passed',
                        header: 'Date Passed',
                        type: 'text'
                    }
                ],
                span: 12
            }
        ]
    },
    {
        sectionID: TCDWCL_EMPLOYMENT_DETAILS,
        sectionName: 'Employment Details',
        fieldList: [
            {
                id: 'self-employed',
                label: 'Self Employed',
                type: 'text'
            }
        ]
    }
];
